export default {
      id: "vide-event_cyclist-collision-usage",
      viewBox: "0 0 55 30",
      url: __webpack_public_path__ + "img/icons.svg#vide-event_cyclist-collision",
      toString: function () {
        return this.url;
      }
    }